import {
  Address,
  AddressSearchResponseItem,
  PassengerAddress,
  TripAddressType,
} from '../types';

export const formatSearchItemAddressWithHouseLetter = (
  address: AddressSearchResponseItem,
  houseLetter: string
) => {
  const street = [address?.streetName, `${address.houseNo} ${houseLetter}`]
    .filter(Boolean)
    .join(' ');
  const city = [address?.zipCode, address.city].join(' ');
  return [street, city].join(', ');
};

const buildPassengerAddressStreet = (item: AddressSearchResponseItem) => ({
  name: item?.streetName,
  city: item?.city,
  zipCode: item?.zipCode != null ? String(item.zipCode) : undefined,
});

export const transformAddressSearchResponseItem = (
  type: number,
  addressItem: AddressSearchResponseItem,
  houseLetter = ''
): PassengerAddress => ({
  type: type,
  streetID: addressItem.streetNo,
  houseNo: addressItem.houseNo,
  houseLetter: houseLetter,
  pOIId: addressItem.poiNo != null ? Number(addressItem.poiNo) : undefined,
  formattedAddress:
    houseLetter && !addressItem.poiNo
      ? formatSearchItemAddressWithHouseLetter(addressItem, houseLetter)
      : addressItem.address,
  floor: '',
  door: '',
  street: buildPassengerAddressStreet(addressItem),
  pOI: {
    name: addressItem?.poiName,
    houseNo: addressItem?.houseNo,
    houseLetter: addressItem?.houseLetter,
    floor: '',
    door: '',
  },
});

const getSearchItemZipCode = (address: PassengerAddress): string | undefined =>
  address.street?.zipCode || undefined;

export const transformAddressToSearchItem = (
  address: PassengerAddress
): AddressSearchResponseItem => ({
  address: address.formattedAddress,
  city: address?.street?.city,
  houseLetter: address.houseLetter,
  houseNo: address.houseNo,
  poiName: address.pOI?.name,
  poiNo: address.pOIId,
  streetName: address?.street?.name,
  streetNo: address.streetID,
  zipCode: getSearchItemZipCode(address),
});

const buildAddressStreetFields = (address: PassengerAddress) => ({
  city: address.street?.city || '',
  streetName: address.street?.name || '',
  zipCode: address.street?.zipCode || '',
});

export function transformPersonAddressToAddress(
  address: PassengerAddress,
  addressType: TripAddressType
): Address {
  const streetFields = buildAddressStreetFields(address);
  return {
    city: streetFields.city,
    coordinates: {
      x: 0,
      y: 0,
    },
    countryCode: '',
    door: address.door,
    floor: address.floor,
    fullAddress: address.formattedAddress,
    houseLetter: address.houseLetter,
    houseNo: address.houseNo,
    pOIId: address.pOIId,
    pOIName: address.pOI?.name,
    poiname: address.pOI?.name,
    streetID: address.streetID,
    streetName: streetFields.streetName,
    type: addressType,
    zipCode: streetFields.zipCode,
  };
}
